import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorCodeTranslationService } from 'src/app/shared/services/errorcode-translation/errorcode-translation.service';
import { DataService } from '../../../../data.service';
import { LocalStorageKeys } from '../../../LocalStorageKeys';
import { FireboltService } from '../../../services/firebolt.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { NavigationLibraryService } from '../../../services/navigation/navigation.service';
import { RoutingService } from '../../../services/routing/routing.service';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent implements OnInit {
  message = 'Unknown Error';
  errorCode: string;
  showCloseButton = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      code: string;
      description: string;
      source: string;
      closeOnly: boolean;
    },
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    private errorCodeService: ErrorCodeTranslationService,
    private router: Router,
    private dataService: DataService,
    private navService: NavigationLibraryService,
    private routingService: RoutingService,
    private localStorage: LocalStorageService,
    private fireboltService: FireboltService
  ) {}

  async ngOnInit(): Promise<void> {
    this.navService.focusContainer('general-error-dialog', true, 0, true, 1000);
    if (this.data) {
      try {
        this.message = this.data.description;
        this.errorCode = this.data.code;
        const { message, description, type } = await this.errorCodeService.getErrorByCode(this.data.code, this.data.description);
        this.message = message ?? this.data.description;
        this.fireboltService.reportError(type, this.errorCode, description);
      } catch (e) {
        this.message = 'Unknown Error';
        this.fireboltService.reportError('other', this.errorCode, this.message);
      }
    }
  }

  async ok(): Promise<void> {
    if (!this.data?.closeOnly) {
      if (this.data?.source) {
        await this.routingService.navigatePlayerUrl(this.data.source);
      } else {
        this.localStorage.setItem(LocalStorageKeys.TAB_CHANGED, 'true');
        await this.router.navigate([`${this.dataService.homeTab}`], { state: { tabId: this.dataService.homeTab } });
      }
    }
    this.dialogRef.close('ok');
  }

  close(): void {
    if (!!this.data?.source) {
      this.ok();
    } else {
      this.dialogRef.close('ok');
    }
  }
}
